module.exports = __webpack_public_path__ + "assets/line_dashed--yellow.88587ea5.svg";